import { Headline, Headlines } from '@agilox/ui-common';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
	selector: 'ui-headline',
	imports: [NgTemplateOutlet, NgClass],
	templateUrl: './headline.component.html',
})
export class HeadlineComponent {
	type = input<Headline>(Headlines.H2);
	ellipsis = input<boolean>(false);
	noPadding = input<boolean>(false);

	styles = computed(() => {
		const base = 'font-semibold mt-0';
		const type = this.type();

		const sizeMap: Record<Headline, string> = {
			[Headlines.H1]: ' leading-[1.1] text-[1.75rem] md:text-[2rem]',
			[Headlines.H2]: ' text-2xl md:text-[1.75rem] md:leading-[1.1]',
			[Headlines.H3]: ' text-xl md:text-2xl',
			[Headlines.H4]: ' text-base md:text-xl',
		};

		const paddingMap: Partial<Record<Headline, string>> = {
			[Headlines.H1]: ' pb-6',
			[Headlines.H2]: ' pb-6',
			[Headlines.H3]: ' pb-4',
			[Headlines.H4]: ' pb-3',
		};

		const padding = this.noPadding() ? '' : (paddingMap[type] ?? '');
		return `${base}${sizeMap[type] ?? ''}${padding}`;
	});
}
